'use client'
import Button, { buttonClassNames } from '@components/primitives/Button'
import { Icon } from '@components/primitives/Icon'
import { classMerge } from '@components/utilities/classMerge'
import { faChevronUp } from '@fortawesome/pro-solid-svg-icons/faChevronUp'

export const BackToTopText = ({
  className = '',
  size = 'medium',
  variant = 'white',
}: {
  className?: string
  size?: 'small' | 'medium'
  variant?: 'black' | 'white'
}) => {
  return (
    <Button
      className={classMerge(
        variant === 'white'
          ? buttonClassNames.text.white
          : buttonClassNames.text.black,
        size === 'small' ? 'text-sm' : '',
        'font-semibold',
        className,
      )}
      onClick={() => window.scrollTo({ behavior: 'smooth', top: 0 })}
    >
      <Icon
        className='mr-1.5'
        icon={faChevronUp}
        size={size === 'medium' ? '1x' : 'sm'}
      />
      Back to top
    </Button>
  )
}
